import React, { useEffect, useState } from 'react';

const videos = [
  {
    title: 'Mind Power : त्यांनी 1 CR चे Dream Home Manifest केले.',
    url: 'https://www.youtube.com/embed/Pjr2NsgY3oc',
    thumbnail: 'https://img.youtube.com/vi/Pjr2NsgY3oc/hqdefault.jpg',
    duration: '00:22',
  },
  {
    title: 'Mind Power : 1 महिन्याच्या आत तिने तिचे Income सुधारले.',
    url: 'https://www.youtube.com/embed/0t96AQMO7u0',
    thumbnail: 'https://img.youtube.com/vi/0t96AQMO7u0/hqdefault.jpg',
    duration: '01:15',
  },
  {
    title: 'Mind Power : तिने 8 वर्षांपासून 30 लाखांच्या कर्जातून स्वतःला मुक्त केले.',
    url: 'https://www.youtube.com/embed/Nwm4sGEw9Rs',
    thumbnail: 'https://img.youtube.com/vi/Nwm4sGEw9Rs/hqdefault.jpg',
    duration: '01:10',
  },
  {
    title: 'Mind Power : आयुष्याकडे बघण्याचा तिचा दृष्टिकोन पूर्णपणे बदलला.',
    url: 'https://www.youtube.com/embed/Ew6B-u-tJmo',
    thumbnail: 'https://img.youtube.com/vi/Ew6B-u-tJmo/hqdefault.jpg',
    duration: '00:48',
  },
];

const SuccessStories = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getColumnCount = () => {
    if (windowWidth <= 600) return 1;
    if (windowWidth <= 1024) return 2;
    if (windowWidth <= 1440) return 2;
    return 2; // 4 columns for larger desktops
  };

  const columns = getColumnCount();

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>पहा आमच्या Past Students चं काय म्हणणं आहे</h2>
      <p style={styles.subtitle}>
        असे काहीतरी कारण असले पाहिजे ज्यामुळे 20,000+ लोकांनी आनंदाने या training साठी sign up केलं आहे.
      </p>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: '20px',
          maxWidth: ' 1000px',
          margin: '0 auto',
        }}
      >
        {videos.map((video, index) => (
          <div key={index} style={styles.card}>
            <div style={styles.topBar}>
              <p style={styles.videoTitle}>{video.title}</p>
            </div>
            <div style={styles.videoWrapper}>
              <a href={video.url} target="_blank" rel="noopener noreferrer">
                <img src={video.thumbnail} alt={video.title} style={styles.thumbnail} />
                <div style={styles.playIcon}>▶</div>
                <div style={styles.duration}>{video.duration}</div>
              </a>
            </div>
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <button style={styles.button(windowWidth)}>
          Join The 2 Day Workshop for ₹199 &nbsp;
          <span style={{ textDecoration: 'line-through', opacity: 0.8 }}>₹999</span>
        </button>
        <p style={styles.ctaNote}>
          <span style={{ fontWeight: '600' }}>Registrations End on </span>
          <span style={{ fontWeight: 'bold', color: 'red' }}>11 JUL</span> <br />
          <span style={{ fontWeight: '600' }}>100%</span> मनी बॅक गॅरंटी | समाधानी नसल्यास
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    background: '#f1e7e7',
    padding: '60px 20px',
    fontFamily: 'outfit, sans-serif',
    textAlign: 'center',
  },
  title: {
    fontSize: '32px',
    fontWeight: 'bold',
    color: '#333333',
  },
  subtitle: {
    fontSize: '20px',
    color: '#000',
    marginBottom: '40px',
  },
  card: {
    backgroundColor: '#0a1a48',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: '0 6px 18px rgba(0, 0, 0, 0.3)',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  topBar: {
    background: 'linear-gradient(to right, #06172f, #112a54)',
    padding: '12px 16px',
    minHeight: '80px',
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
    fontSize: '18px',
    fontWeight: 600,
  },
  videoTitle: {
    color: '#fff',
    fontSize: '16px',
    lineHeight: '1.4',
  },
  videoWrapper: {
    position: 'relative',
    width: '100%',
    height: '210px',
    overflow: 'hidden',
  },
  thumbnail: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  playIcon: {
    position: 'absolute',
    top: 'calc(50% - 25px)',
    left: 'calc(50% - 25px)',
    width: '50px',
    height: '50px',
    background: '#ffffffcc',
    borderRadius: '50%',
    fontSize: '24px',
    lineHeight: '50px',
    textAlign: 'center',
    color: '#000',
    cursor: 'pointer',
  },
  duration: {
    position: 'absolute',
    bottom: '8px',
    left: '10px',
    background: '#000',
    color: '#fff',
    fontSize: '12px',
    padding: '2px 6px',
    borderRadius: '4px',
  },
  button: (width) => ({
    background: 'linear-gradient(49.12deg, #ffc74b 0, #e39600 22%)',
    color: 'white',
    fontSize: width <= 768 ? '18px' : '20px',
    padding: width <= 768 ? '10px 40px' : '25px 80px',
    border: 'none',
    borderRadius: '20px',
    fontWeight: 'bold',
    cursor: 'pointer',
    width: width <= 768 ? '100%' : 'auto',
  }),
  ctaNote: {
    marginTop: '10px',
    color: 'black',
    fontSize: '16px',
    fontFamily: 'outfit,sans-serif',
    fontStyle: 'italic',
  },
};

export default SuccessStories;
